module.exports = __webpack_public_path__ + "static/media/mongodb-dark.8396442f.png";